import React from 'react'

const ServerSideContext = React.createContext(true)

export default ServerSideContext
